<template>
    <div>
		<tab name="1"></tab>
        <div class="page-btns-box">
            <el-button v-if="$utils.have('/daping/pw/save')" type="primary" icon="el-icon-plus" size="small"
                @click="$refs.add.show()">新建</el-button>
        </div>
        <div class="page-list-box">
            <el-descriptions title="数据看板链接" :column="2" border size="small">
                <el-descriptions-item label="看板1访问地址">
                    <div slot="label">看板1 <el-tag type="info" size="mini">即将废弃</el-tag></div>
                    <el-link type="primary" size="small" :href="`${ssfb}/entrance`"
                        target="_blank">{{ ssfb }}/entrance</el-link>
                </el-descriptions-item>
                <el-descriptions-item label="看板2访问地址">
                    <div slot="label">看板2 <el-tag type="info" size="mini">即将废弃</el-tag></div>
                    <el-link type="primary" size="small" :href="`${ssfb}/Ticketcheck`"
                        target="_blank">{{ ssfb }}/Ticketcheck</el-link>
                </el-descriptions-item>
                <el-descriptions-item label="公共看板v1"><el-link type="primary" size="small" :href="`${daping}/index?mc=fb`"
                        target="_blank">{{ daping }}/index?mc=fb</el-link></el-descriptions-item>
                <el-descriptions-item label="公共看板v2">
                    <div slot="label">公共看板v2 <el-tag type="danger" size="mini">推荐</el-tag></div>
                    <el-link type="primary" size="small" :href="`${daping}/v2?mc=fb`"
                        target="_blank">{{ daping }}/v2?mc=fb</el-link>
                </el-descriptions-item>
            </el-descriptions>
            <el-table :data="dataList" border style="width: 100%" v-loading="listLoading" size="small" stripe class="MT20">
                <el-table-column prop="address" label="城市"></el-table-column>
                <el-table-column prop="activityTitle" label="演出名称" show-overflow-tooltip min-width="150"></el-table-column>
                <el-table-column prop="activityId" label="演出ID"></el-table-column>
                <el-table-column prop="sessionName" label="场次名称" show-overflow-tooltip min-width="100"></el-table-column>
                <el-table-column prop="sessionId" label="场次ID"></el-table-column>
                <el-table-column prop="timeInfo" label="时间" min-width="160"></el-table-column>
                <el-table-column prop="applus" label="报批人数"></el-table-column>
                <el-table-column label="操作" fixed="right" width="80">
                    <template slot-scope="scope">
                        <el-button v-if="$utils.have('/daping/pw/save')" type="text" size="small" icon="el-icon-edit" @click="$refs.add.show(scope.row)">管理
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination background @size-change="handleSizeChange" @current-change="getDataList"
                :current-page.sync="params.pageNo" :page-sizes="$pageSizes" :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next" :total="data.totalCount || 0">
            </el-pagination>
        </div>
        <add ref="add" @onUpdate="getDataList"></add>
    </div>
</template>
<script>
import Add from "./components/add.vue";
import Tab from './components/tab'
const defaultParams = {
    pageNo: 1,
}
export default {
    components: { Add ,Tab},

    data() {
        return {
            data: null,
            dataList: null,
            params: {
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0])
            },
            listLoading: true,
            ssfb:process.env.VUE_APP_SSFB_URL,
            daping:process.env.VUE_APP_DAPING,
        }
    },
    mounted() {
        this.getDataList();
    },
    methods: {
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/daping/pw/list",
                method: "POST",
                params: {
                    ...this.params
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        }
    }
}
</script>

<style lang="scss" scoped>
</style>